<template>
  <div>
    <el-dialog title="每周执行进度" :visible.sync="recordVisible" :close-on-click-modal="false" top="50px" width="600px">
      <div v-for="record in recordList" :key="record.recordId">
        <StackRecordItem :record="record" :recordType="recordType" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import StackRecordItem from './stack-record-item'
export default {
  name: 'stack-record-dialog',
  components: {
    StackRecordItem
  },
  data () {
    return {
      recordVisible: false,
      recordList: [],
      recordType: ''
    }
  },
  methods: {
    setRecordList (list) {
      this.recordType = 'trade'
      this.recordList = list
      // 设置图片
      this.recordList.forEach(item => {
        let stackImgList = []
        if (item.stackDetailFileUri) {
          stackImgList.push(
            { imgUrl: this.getImg(item.stackDetailFileUri), imgStatus: item.stackDetailCheckResult },
            { imgUrl: this.getImg(item.stackFrontFileUri), imgStatus: item.stackFrontCheckResult },
            { imgUrl: this.getImg(item.stackFullFileUri), imgStatus: item.stackFullCheckResult }
          )
        }
        this.$set(item, 'stackImgList', stackImgList)
      })

      this.recordVisible = true
    },

    setPerfectRecordList (list) {
      console.log(list)
      this.recordType = 'perfect'
      this.recordList = list
      this.recordVisible = true
      this.recordList.forEach(item => {
        item.tradePerfectTrackTaskList = item.tradePerfectTrackTaskList || []
      })
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  background-color: #f3f5f9;
  max-height: 600px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 15px 15px 15px;
}
</style>
